import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { useIntl } from 'react-intl';
import { handleErrorNotification } from 'Common/utils';
import { useApiClient } from '../../../utils/apiClient';

export const useAccountingSetup = () => {
  const apiClient = useApiClient();
  return useQuery({
    queryKey: ['accounting', 'setup'],
    queryFn: apiClient.Settings.AccountingApi.getAccountingSetup,
    retry: false,
    gcTime: 1500,
    refetchOnWindowFocus: false,
  });
};

export const useSaveAccountingSetup = () => {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();
  const intl = useIntl();
  return useMutation({
    mutationFn: apiClient.Settings.AccountingApi.submitAccountingSetup,
    onSuccess(data) {
      queryClient.invalidateQueries({
        queryKey: ['accounting', 'setup'],
      });
      if (Object.keys(data).length === 0) {
        queryClient.cancelQueries({
          queryKey: ['accounting', 'product-groups'],
        });
      }
      message.success(
        intl.formatMessage({
          defaultMessage: 'Accounting Settings successfully saved.',
        })
      );
    },

    onError(error) {
      handleErrorNotification({
        error,
        lang: intl.locale.toLowerCase(),
      });
    },
  });
};
